/* esm.sh - react-router@7.15.1 */
export * from "/*react-router@7.15.1/esnext/react-router.mjs";
